import { IGetManutencaoEquipObraByIdUseCase } from "../../../presentation/useCases/read/get_manutencao_equip_obra_by_id_use_case";
import { ManutencaoEquipObra } from "../../models/manutencao_equip_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetManutencaoEquipObraByIdUseCase
 */

export class GetManutencaoEquipObraByIdUseCase implements IGetManutencaoEquipObraByIdUseCase {
  constructor(private readonly repository: IObrasRepository) {
  }

  async execute(idManutencaoEquipObra: number): Promise<ManutencaoEquipObra> {
    return this.repository.getManutencaoEquipObraById(idManutencaoEquipObra);


  }
}
